import BrandApi from "../../../../services/api/brandApi";
import InlineSvg from "vue-inline-svg";
import BrandValueIcon from "../../../../components/shared/brandValueIcon/brandValueIcon.vue";
import PostImageWithProductCarousel from "../../PostImageWithProductCarousel.vue";
import PostLink from "../../PostLink.vue";
import PostCaption from "@/views/TheDiscoveryFeed/PostCaption";

import BrandValuesList from "@/views/TheDiscoveryFeed/BrandValuesList";

const brandApiService = new BrandApi();
export default {
  components: {
    InlineSvg,
    BrandValueIcon,
    PostImageWithProductCarousel,
    PostLink,
    PostCaption,
    BrandValuesList,

  },
  props: ["draft-post"],
  data() {
    return {
      brandData: null,
    };
  },
  mounted() {
    if (this.$session.getUserInfo().role === "BRAND") {
      brandApiService.getBrandMe().then(({ data }) => {
        this.brandData = {
          brand_thumbnail_image_url: data.thumbnail_image_url,
          name: data.brand_name,
          values: data.values.map((value) => value.value),
        };
      });
    }
  },
};
